import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import HighSchoolDetails from './details-display';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query HighSchoolDetailsDisplay($id: String!) {
    viewer {
      id
      enabledFeatures
    }
    highSchoolBySchoolId(id: $id) {
      id
      name
      general {
        field_hs_na_nces_id
        field_hs_elna_school_type
      }
      naviance {
        field_hs_na_nguid
        field_hs_elna_phone
        field_hs_na_percent_college
        field_hs_na_district_title
      }
      address {
        field_hs_elna_location_latlon {
          latitude
          longitude
        }
        field_hs_elna_address_line1
        field_hs_elna_city
        field_hs_elna_state_latest
        field_hs_eln_zip
      }
      repVisitsAccount {
        id
        primaryContact {
          id
          mail
          name
        }
        collegeFairsPrimaryContact {
          id
          mail
          name
        }
      }
      enrollmentByGrade {
        field_hs_el_grade_12_students
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id }) => ({
    variables: {
      id,
    },
  }),
});

export default SimpleLoadingComponent(graphqlData)(HighSchoolDetails);
